// @ts-nocheck
export default {
    getterSelectedSettingGroupName: ({ selectedSettingGroup }) => selectedSettingGroup.name ?? '',
    getterSelectedSettingGroupId: ({ selectedSettingGroup }) => selectedSettingGroup.id ?? 0,
    getterIsSelectedSettingGroupDefault: ({ selectedSettingGroup }) => selectedSettingGroup.defaultYn === 'Y',
    getterFilterOptionSearchWord: (state) => state.filterOption.searchWord.value ?? '',
    // 필요한 값을 매핑한 List
    getterPenaltyGroupWorkerList: (state) => state.penaltyGroupWorkerList?.map((it) => ({
        ...it,
        groupName: it.workerPenaltyGroupDTO.name,
        defaultYn: it.workerPenaltyGroupDTO.defaultYn,
    })),
    getterPenaltyGroupAvailableWorkerList: (state) => state.penaltyGroupAvailableWorkerList?.map((it) => ({
        ...it,
        groupName: it.workerPenaltyGroupDTO.name,
        defaultYn: it.workerPenaltyGroupDTO.defaultYn,
    })),
    // (기본(등록가능한) - registerList + unregisterList) 을 검색값을 이용해 필터링 한 List
    // 테이블에서는 이 값을 사용.
    getterFilteredPenaltyGroupAvailableWorkerList: (state, { getterFinalPenaltyGroupAvailableWorkerList }) => getterFinalPenaltyGroupAvailableWorkerList.filter((worker) => worker.name.includes(state.filterOption.searchWord.value)),
    // 기본 - unregisterList + registerList
    getterFinalPenaltyGroupWorkerList: (state, { getterPenaltyGroupWorkerList }) => getterPenaltyGroupWorkerList
        .filter((worker) => !state.unregisterList.some((unregister) => unregister.code === worker.code))
        .concat(state.registerList),
    // 기본(등록가능한) - registerList + unregisterList
    getterFinalPenaltyGroupAvailableWorkerList: (state, { getterPenaltyGroupAvailableWorkerList }) => getterPenaltyGroupAvailableWorkerList
        .filter((worker) => !state.registerList.some((register) => register.code === worker.code))
        .concat(state.unregisterList),
    getterRegisters: (state) => state.registerList?.map((register) => register.code) ?? [],
    getterUnregisters: (state) => state.unregisterList?.map((unregister) => unregister.code) ?? [],
    getterPenaltyGroupWorkerListLength: (state, { getterFinalPenaltyGroupWorkerList }) => getterFinalPenaltyGroupWorkerList.length,
    getterAvailableWorkerListLength: (state, { getterFinalPenaltyGroupAvailableWorkerList }) => getterFinalPenaltyGroupAvailableWorkerList.length,
    getterIsChanged: (state, { getterRegisters, getterUnregisters, }) => getterRegisters.length || getterUnregisters.length,
};
